var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.new_costs
      ? _c("section", { staticClass: "results" }, [
          _c("div", {}, [
            _vm.new_costs
              ? _c(
                  "div",
                  {
                    staticClass: "results__table",
                    staticStyle: { overflow: "visible !important" }
                  },
                  [
                    _c("table", [
                      _c("tr", [
                        _c("td", { staticClass: "noStyle" }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "highlightRow",
                            attrs: { colspan: "7" }
                          },
                          [
                            _vm._v(
                              "\n              your potential savings\n              "
                            ),
                            _vm.quote.machines_amount > 1
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "inherit",
                                      "font-weight": "inherit"
                                    }
                                  },
                                  [_vm._v("when opting for full fleet:")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              staticStyle: {
                                "font-size": "inherit",
                                "font-weight": "inherit"
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.new_costs && _vm.new_costs[0]
                                    ? _vm.mnwp(
                                        _vm.maxSavingOverTerm(
                                          _vm.results.new_costs[0]
                                        )
                                      )
                                    : "N/A"
                                )
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("td", { staticClass: "image" }, [
                              _vm.current_costs && _vm.current_costs.printer
                                ? _c("img", {
                                    class: {
                                      stamps: _vm.current_costs.printer.id == 1
                                    },
                                    attrs: {
                                      src: _vm.printerImage(
                                        _vm.current_costs.printer.image_url
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.current_costs &&
                                        _vm.current_costs.printer
                                        ? _vm.current_costs.printer.manufacturer
                                            .name
                                        : ""
                                    ) +
                                    "\n                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.current_costs &&
                                        _vm.current_costs.printer
                                        ? _vm.current_costs.printer.model
                                        : ""
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "innerTable" }, [
                              _c("table", [
                                _c("tr", [
                                  _c("td", [
                                    _c("h6", [_vm._v("Standard")]),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.current_costs &&
                                            _vm.current_costs.printer
                                            ? _vm.current_costs.printer
                                                .speed_standard
                                            : 0
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", [
                                    _c("h6", [_vm._v("Auto size and weight")]),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.current_costs &&
                                            _vm.current_costs.printer
                                            ? _vm.current_costs.printer
                                                .auto_size_weight
                                            : 0
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.current_costs && _vm.current_costs.printer
                                    ? _vm.current_costs.printer
                                        .envelope_thickness_capacity
                                    : 0
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.current_costs && _vm.current_costs.printer
                                    ? _vm.current_costs.printer.scale_capacity
                                    : 0
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.current_costs &&
                            _vm.current_costs.printer &&
                            _vm.current_costs.printer.model === "Stamps"
                              ? _c("td", [_vm._v("N/A")])
                              : _c("td", [_vm._v("AS PER EXISTING")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.current_costs
                                    ? _vm.current_costs.rating
                                    : 0
                                ) +
                                  "/" +
                                  _vm._s(
                                    _vm.results ? _vm.results.max_rating : 0
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "largeText blue" }, [
                              _vm._v("N/A")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.new_costs, function(costs, index) {
                            return _vm.new_costs && !_vm.costsHasError(costs)
                              ? _c("fragment", { key: index }, [
                                  !_vm.costsHasError(costs)
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "rotate red",
                                            attrs: { rowspan: "1" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "25px"
                                                }
                                              },
                                              [_vm._v("proposed")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "image" }, [
                                          costs.printer
                                            ? _c("img", {
                                                attrs: {
                                                  src: _vm.printerImage(
                                                    costs.printer.image_url
                                                  )
                                                }
                                              })
                                            : _vm._e(),
                                          _c("br"),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                costs.printer
                                                  ? costs.printer.manufacturer
                                                      .name
                                                  : ""
                                              ) +
                                              "\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                costs.printer
                                                  ? costs.printer.model
                                                  : ""
                                              ) +
                                              "\n              "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "innerTable" },
                                          [
                                            _c("table", [
                                              _c("tr", [
                                                _c("td", [
                                                  _c("h6", [
                                                    _vm._v("Standard")
                                                  ]),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        costs.printer
                                                          ? costs.printer
                                                              .speed_standard
                                                          : 0
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [
                                                  _c("h6", [
                                                    _vm._v(
                                                      "Auto size and weight"
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        costs.printer
                                                          ? costs.printer
                                                              .auto_size_weight
                                                          : 0
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ])
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              costs.printer
                                                ? costs.printer
                                                    .envelope_thickness_capacity
                                                : 0
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              costs.printer
                                                ? costs.printer.scale_capacity
                                                : 0
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              costs.printer
                                                ? costs.printer.service_name
                                                : "-"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              costs.printer ? costs.rating : 0
                                            ) +
                                              "/" +
                                              _vm._s(
                                                _vm.results
                                                  ? _vm.results.max_rating
                                                  : 0
                                              )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "largeText red" },
                                          [
                                            _c("span", {
                                              staticStyle: {
                                                "white-space": "nowrap"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  costs
                                                    ? _vm.mnwp(
                                                        _vm.maxSavingOverTerm(
                                                          costs
                                                        )
                                                      )
                                                    : "N/A"
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dashboard-results-comparison" },
              _vm._l(_vm.new_costs, function(costs, index) {
                return _vm.new_costs && !_vm.costsHasError(costs)
                  ? _c(
                      "table",
                      { key: index },
                      [
                        costs.printer
                          ? _c("more-info-tr", {
                              attrs: {
                                quote: _vm.quote,
                                new_costs: costs,
                                current_costs: _vm.current_costs,
                                model: costs.printer,
                                service_upgrade:
                                  _vm.additionalOptions.service_upgrade,
                                quote_confirmation:
                                  _vm.additionalOptions.quote_confirmation
                              },
                              on: {
                                "progress-with-order": function(
                                  investment_option
                                ) {
                                  return _vm.onProgressWithOrder(
                                    investment_option,
                                    _vm.quote,
                                    costs,
                                    _vm.additionalOptions,
                                    _vm.current_costs
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "noStyle" }),
      _vm._v(" "),
      _c("th", [
        _vm._v("  "),
        _c("br"),
        _vm._v(" manufacture and model"),
        _c("br"),
        _vm._v(" ")
      ]),
      _vm._v(" "),
      _c("th", [_vm._v("speed (letters per minute)  ")]),
      _vm._v(" "),
      _c("th", [_vm._v("envelope thickness capacity")]),
      _vm._v(" "),
      _c("th", [_vm._v("standard scale capacity")]),
      _vm._v(" "),
      _c("th", [_vm._v("service/maintenance offering")]),
      _vm._v(" "),
      _c("th", [_vm._v("quick view product rating")]),
      _vm._v(" "),
      _c("th", [_vm._v("YOUR POTENTIAL SAVINGS ON NEW TERM")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rotate blue", attrs: { rowspan: "1" } }, [
      _c("div", { staticStyle: { "font-size": "25px" } }, [_vm._v("current")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f11de286", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f11de286","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProposalTemplate/Summary.vue
// module id = null
// module chunks = 